var map = {
	"./ar-SA.json": 46091,
	"./en-GB.json": 32998,
	"./es-MX.json": 75735,
	"./fr-FR.json": 85090,
	"./ja-JP.json": 34707,
	"./ko-KR.json": 83989,
	"./pt-BR.json": 74662,
	"./template.json": 84077,
	"./tl-PH.json": 8742,
	"./vi-VN.json": 89689,
	"./zh-CN.json": 2221,
	"./zh-TW.json": 42785
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10424;